import { useCallback, useState } from 'react';
import { updateLessonProgress } from '../services/lessons';

export function useUpdateLessonProgress() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const saveProgress = useCallback(async (lessonId, payload) => {
    setLoading(true);
    setError(null);

    try {
      const response = await updateLessonProgress(lessonId, payload);
      return response;
    } catch (e) {
      const message = e?.message || 'Failed to update lesson progress';
      setError(message);
      return { success: false, message };
    } finally {
      setLoading(false);
    }
  }, []);

  return { saveProgress, loading, error };
}
